import classNames from "classnames";
import P from "components/Typography/P";
import React from "react";

import styles from "./ContentCard.module.scss";

interface Props {
    title: string;
    coverImage: string;
    description?: string;
    tags?: string[];
    classes?: {
        root?: string;
        header?: string;
        coverImage?: string;
        content?: string;
        title?: string;
        description?: string;
        bottom?: string;
        tag?: string;
    };
    onClick: () => void;
}

const ContentCard = ({ title, coverImage, description, classes, onClick, tags }: Props) => {
    return (
        <article
            onClick={onClick}
            role="presentation"
            className={classNames(styles.card, classes?.root)}
        >
            <div className={classNames(styles["card__header"], classes?.header)}>
                <div
                    className={classNames(styles["card__cover-image"], classes?.coverImage)}
                    style={{
                        backgroundImage: `url(${coverImage})`,
                    }}
                />
            </div>
            <div className={classNames(styles["card__content"], classes?.content)}>
                <h4 className={classNames(styles["card__title"], classes?.title)}>{title}</h4>
                <div className={styles["card__tags"]}>
                    {tags?.map((tag, index) => {
                        return (
                            <span
                                key={index}
                                className={classNames(styles["card__tag"], classes?.tag)}
                            >
                                {tag}
                            </span>
                        );
                    })}
                </div>
                {description && (
                    <P className={classNames(styles["card__description"], classes?.description)}>
                        {description}
                    </P>
                )}
            </div>
            <div className={classNames(styles["card__bottom"], classes?.bottom)}></div>
        </article>
    );
};

export default ContentCard;
